import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.is-array";
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
import store from '@/store';
/**
 * 从路由树中根据 name 递归查找对应的 meta.buttons 按钮权限
 * @param {Array} routes - 路由树数组（如 store 中的 addRouters）
 * @param {string} targetName - 目标路由名称
 * @returns {Array} 按钮权限数组，未找到返回 []
 */
function findButtonsByRouteName(routes, targetName) {
  if (!routes || !Array.isArray(routes)) return [];
  var _iterator = _createForOfIteratorHelper(routes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var route = _step.value;
      if (route.name && route.name === targetName) {
        var _route$meta;
        return ((_route$meta = route.meta) === null || _route$meta === void 0 ? void 0 : _route$meta.buttons) || [];
      }
      if (route.children && route.children.length) {
        var childResult = findButtonsByRouteName(route.children, targetName);
        if (childResult && childResult.length) {
          return childResult;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return [];
}

/**
 * 根据路由名称获取对应的按钮权限数组
 * @param {Object} store - Vuex store 实例
 * @param {string} routeName - 路由名称
 * @returns {Array} 按钮权限数组
 */
function getButtonsByRouteNameFromStore(store, routeName) {
  var _store$state;
  // 非空判断：确保 store 和路由数据存在
  var routes = store === null || store === void 0 || (_store$state = store.state) === null || _store$state === void 0 || (_store$state = _store$state.permission) === null || _store$state === void 0 ? void 0 : _store$state.addRouters;
  if (!routes || !Array.isArray(routes)) {
    console.warn('[getButtonsByRouteNameFromStore] 路由数据不存在或不是数组');
    return [];
  }
  return findButtonsByRouteName(routes, routeName);
}

// 注意：以下两个方法会在挂载时绑定到 Vue.prototype.$auth 中，
// 它们内部通过 this.$store 获取 store，因此不能在普通函数中直接导出使用。

/**
 * 检查当前用户是否拥有某个菜单权限（全局权限标识）
 * @param {string} permissionKey - 权限标识，例如 'trialApplication'
 * @returns {boolean} 有权限返回 true，否则 false
 */
export function checkMenuPermission(permissionKey) {
  var _store$state2;
  // 注意：这个方法在挂载后会通过 this.$auth.menu 调用，this 指向组件实例
  if (!store) {
    console.warn('[checkMenuPermission] 无法获取 $store');
    return false;
  }
  var allKeys = (_store$state2 = store.state) === null || _store$state2 === void 0 || (_store$state2 = _store$state2.permission) === null || _store$state2 === void 0 ? void 0 : _store$state2.allPermissionKey;
  return Array.isArray(allKeys) && allKeys.includes(permissionKey);
}

/**
 * 检查当前用户是否拥有某个路由下的指定按钮权限
 * @param {string} routeName - 路由名称
 * @param {string} buttonKey - 按钮权限标识，例如 'add', 'edit'
 * @returns {boolean} 有权限返回 true，否则 false
 */
export function checkButtonPermission(routeName, buttonKey) {
  var buttons = getButtonsByRouteNameFromStore(store, routeName);
  return Array.isArray(buttons) && buttons.includes(buttonKey);
}

// 最终挂载到 Vue.prototype 的对象
export var permission = {
  checkMenuPermission: checkMenuPermission,
  // 检查菜单权限
  checkButtonPermission: checkButtonPermission // 检查按钮权限
};